import { render, staticRenderFns } from "./CompensationTypeManager.vue?vue&type=template&id=dde34c1a"
import script from "./CompensationTypeManager.vue?vue&type=script&lang=js"
export * from "./CompensationTypeManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports